import React from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description?: string;
  canonicalUrl?: string;
  robots?: string[];
  jsonLd?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonicalUrl,
  robots = [],
  jsonLd,
}) => {
  const jsonLdData = jsonLd
    ? jsonLd?.replace(/<script.*?>(.*?)<\/script>/, "$1")
    : null;

  return (
    <Helmet>
      <title>{title ?? "MESC"}</title>
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {robots.length > 0 && <meta name="robots" content={robots.join(", ")} />}
      {jsonLdData && (
        <script type="application/ld+json" data-react-helmet="true">
          {jsonLdData}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
